module.exports = __webpack_public_path__ + "static/media/Page-1-1.75db29f1.svg";